<template>
  <div class="search-nav-year-month">
    <span class="year-month-title">{{label}}</span>
    <span><search-nav-item-select class="mr-2" v-model="year" :list="yearList" size="small" @change="onChangeData"/>년</span>
    <span><search-nav-item-select class="mr-2" v-model="month" :list="monthList" size="small"  @change="onChangeData"/>월</span>
  </div>
</template>

<script>
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'
export default {
  name: 'SearchNavYearMonth',
  components: {SearchNavItemSelect},
  props:{
    label: {
      default: '대상기간',
      type: String
    },
    value: Object
  },
  computed: {
    yearList () {
      let nowYear = new Date().getFullYear()
      const yearList = []
      yearList.push({text:'전체',  value:''})
      for (let i = 0; i < 50; i++) {
        yearList.push({text:`${nowYear}`,  value:nowYear})
        nowYear--
      }
      return yearList
    },
    monthList () {
      return [
        {text:'전체', value:''},
        {text:'1', value:'1'},
        {text:'2', value:'2'},
        {text:'3', value:'3'},
        {text:'4', value:'4'},
        {text:'5', value:'5'},
        {text:'6', value:'6'},
        {text:'7', value:'7'},
        {text:'8', value:'8'},
        {text:'9', value:'9'},
        {text:'10', value:'10'},
        {text:'11', value:'11'},
        {text:'12', value:'12'}
      ]
    },
    getYearMonthAt () {
      const query = this.$route.query;
      if (query.year || query.month) {
        try {
          return {
            year: query.year ? query.year : '',
            month: query.month ? query.month : '',
          }
        } catch (e) {}
      }
      return {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      }
    },
  },
  data () {
    return {
      year: "",
      month: "",
    }
  },
  created () {
    this.year = this.getYearMonthAt.year
    this.month = this.getYearMonthAt.month
  },
  methods: {
    onChangeData () {
      this.$emit('input', {year:this.year, month:this.month})
      this.$emit('change', {year:this.year, month:this.month})
    }
  }
}
</script>

<style lang="scss" scoped>
.search-nav-year-month {
  display: grid;
  grid-template-columns: 80px 110px 110px;

  .year-month-title { white-space: nowrap;}

  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

}
</style>
